import styled from "styled-components/native";
import { margin } from "styled-system";

export const StyledViewContainer = styled.View`
  ${margin}
  flex-direction: row;
`;
